import React from 'react'
import useTranslator from './use-translator'
import useLocale from './use-locale'
import useOnLocaleLoaded from './use-on-locale-loaded'
import isEqual from 'lodash/isEqual'

export default function useRawTranslation (name, applyNamespace = true) {
  const translator = useTranslator()
  const locale = useLocale()

  function translate () {
    return translator.getRaw(name, applyNamespace)
  }

  const [translation, setTranslation] = React.useState(translate())
  const [currentLocale, setCurrentLocale] = React.useState(locale.get())

  useOnLocaleLoaded((loadedLocale) => {
    setCurrentLocale(loadedLocale)
  })

  React.useEffect(() => {
    if (name === null) {
      return
    }
    const nextTranslation = translate()
    if (!isEqual(nextTranslation, translation)) {
      setTranslation(nextTranslation)
    }
  }, [name, currentLocale])

  return translation
}
